import { createSelector } from 'reselect'
import shouldHideHeaderRouterSelect from 'modules/router/selectors/should-hide-header/index.js'

const shouldHideFooterRouterSelect = createSelector(
  shouldHideHeaderRouterSelect,
  (shouldHideHeader) => {
    return shouldHideHeader
  }
)

export default shouldHideFooterRouterSelect
